import { ModifierGroup } from '@wix/ambassador-ecom-v1-order/types';
import React, { FC } from 'react';
import Text, { TextType } from '../../../../../../../../Components/Text';
import { BookingBodyContentAddOnsInfoDataHooks } from '../../../../../../../datahooks';
import BookingBodyContentAddOnsList from '../BookingBodyContentAddOnsList';
import { classes } from './BookingBodyContentAddOnsInfo.st.css';

export interface BookingBodyContentAddOnsInfoProps {
  addOnGroups: ModifierGroup[];
}

const BookingBodyContentAddOnsInfo: FC<BookingBodyContentAddOnsInfoProps> = ({
  addOnGroups,
}) => {
  return (
    <div
      data-hook={BookingBodyContentAddOnsInfoDataHooks.Main}
      className={classes.addOns}
    >
      {addOnGroups.map((group) => (
        <div key={group.id}>
          <Text
            type={TextType.Secondary}
            data-hook={BookingBodyContentAddOnsInfoDataHooks.Text + group.id}
          >
            {group.name?.translated}
          </Text>
          <BookingBodyContentAddOnsList
            addOns={group.modifiers || []}
            dataHook={
              BookingBodyContentAddOnsInfoDataHooks.AddOnsList + group.id
            }
          />
        </div>
      ))}
    </div>
  );
};

export default BookingBodyContentAddOnsInfo;
